module.exports = __webpack_public_path__ + "resources/img/img_iTracerAF1.b30ce5e6c3803de70fa3348b94ae02a9.png";